export const STEP_SEND_VERIFICATION_CODE = 'STEP_SEND_VERIFICATION_CODE';
export const STEP_CONFIRM_VERIFICATION_CODE = 'STEP_CONFIRM_VERIFICATION_CODE';
export const STEP_CONFIRM_VERIFICATION_CODE_SUCCESS = 'STEP_CONFIRM_VERIFICATION_CODE_SUCCESS';